var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-datepicker',{attrs:{"reset-button":_vm.resetButton,"disabled":_vm.disabled,"min":_vm.min,"max":_vm.max,"value-as-date":"","dropup":"","placeholder":_vm.placeholder,"state":_vm.state},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }